// src/api/useUploadFile.ts
//import { useMutation } from "@tanstack/react-query";
import type { FileItem } from "./Types.ts";

const MAX_BYTES = 20 * 1024 * 1024; // 10MB
const ALLOWED_MIME = "application/pdf";
const baseUrl = import.meta.env.VITE_CONSOLE_API_HOST ?? "";

export type UploadArgs = {
  file: File;
  project: string;
  token: string; // JWT
  onProgress?: (pct: number) => void;
};

export async function uploadViaXHR({ file, project, token, onProgress }: UploadArgs): Promise<FileItem> {
  if (file.type !== ALLOWED_MIME) {
    throw new Error("Only PDF files are allowed.");
  }
  if (file.size > MAX_BYTES) {
    throw new Error("File size must be ≤ 10MB.");
  }

  const form = new FormData();
  form.append("file", file, file.name);

  return new Promise<FileItem>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    console.log("xhr project:", project);
    xhr.open("POST", `${baseUrl}/api/files/upload?project=${encodeURIComponent(project)}`);
    xhr.setRequestHeader("Authorization", `Bearer ${token}`);

    xhr.upload.onprogress = (evt) => {
      console.log("upload progress:", evt);
      if (evt.lengthComputable && onProgress) {
        const pct = Math.round((evt.loaded / evt.total) * 100);
        onProgress(pct);
      }
    };

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      console.log("upload status:", xhr.status);
      const ok = xhr.status >= 200 && xhr.status < 300;
      try {
        const body = xhr.responseText ? JSON.parse(xhr.responseText) : null;
        if (ok) resolve(body as FileItem);
        else reject(new Error(body?.error ?? `Upload failed (${xhr.status})`));
      } catch {
        ok ? resolve(JSON.parse("{}") as FileItem) : reject(new Error(`Upload failed (${xhr.status})`));
      }
    };

    xhr.onerror = () => reject(new Error("Network error while uploading."));
    xhr.send(form);
  });
}
